import { render, staticRenderFns } from "./MainPageRoutinePrint.vue?vue&type=template&id=34c487c3&scoped=true"
import script from "./MainPageRoutinePrint.vue?vue&type=script&lang=js"
export * from "./MainPageRoutinePrint.vue?vue&type=script&lang=js"
import style0 from "./MainPageRoutinePrint.vue?vue&type=style&index=0&id=34c487c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c487c3",
  null
  
)

export default component.exports